import request from 'ykd-base/request'
import { WorkOrder, WorkOrderSubmitParam } from '@/model/coupon/partnerData'
import { Account } from 'ykd-base/account'

export async function submitWorkOrder(
  data: WorkOrderSubmitParam
): Promise<WorkOrder> {
  const res = await request<WorkOrder>({
    method: 'POST',
    biz: 'done',
    url: '/workorder/submit',
    data
  })

  return res && res.data
}

export async function getWortOrderStatus(): Promise<WorkOrder[]> {
  const res = await request<WorkOrder[]>({
    method: 'GET',
    biz: 'done',
    url: '/workorder/query/needcheck'
  })

  return res && res.data
}

export async function getWortOrder(
  orderStatus: string,
  startTime?: string,
  endTime?: string
): Promise<WorkOrder[]> {
  const res = await request<WorkOrder[]>({
    method: 'GET',
    biz: 'done',
    url: '/workorder/query/status',
    params: {
      reviewStatus: orderStatus,
      startTime: startTime,
      endTime: endTime
    }
  })

  return res && res.data
}

export async function getWortOrderCommission(
  startTime: string,
  endTime: string
): Promise<WorkOrder[]> {
  const res = await request<WorkOrder[]>({
    method: 'GET',
    biz: 'done',
    url: `/workorder/query/commission?startTime=${startTime}&endTime=${endTime}`
  })

  return res && res.data
}

export async function review(data: WorkOrder): Promise<WorkOrder> {
  const res = await request<WorkOrder>({
    method: 'POST',
    biz: 'done',
    url: '/workorder/review',
    data
  })
  return res && res.data
}

export async function getPartnerAccount(): Promise<Account> {
  const res = await request<Account>({
    method: 'GET',
    biz: 'done',
    url: '/workorder/query/parter'
  })
  return res && res.data
}
